// extracted by mini-css-extract-plugin
export default {"SurfacePage":"SurfacePage_SurfacePage__vhfaz"};